<template>
  <div></div>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import * as GlowBall from './GlowBall.js'
export default {
  mixins: [O3DG2],
  methods: {
    async setup () {
      await GlowBall.makeScene({ o3d: this.o3d, clean: this.onClean, camera: this.ctx.camera, loop: this.onLoop })
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>

</style>